import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-msg",
  "use": "icon-msg-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-msg\"><defs><style type=\"text/css\"></style></defs><path d=\"M800 102.4H281.6c-96 0-179.2 83.2-179.2 179.2V640c0 96 83.2 179.2 179.2 179.2h19.2s0 6.4 6.4 6.4l70.4 76.8c12.8 12.8 32 12.8 38.4 0l64-70.4 6.4-6.4h313.6c96 0 179.2-83.2 179.2-179.2V281.6c0-96-83.2-179.2-179.2-179.2zM294.4 531.2c-38.4 0-64-32-64-70.4 0-38.4 32-70.4 70.4-70.4 38.4 0 70.4 32 70.4 70.4-6.4 38.4-38.4 70.4-76.8 70.4z m243.2 0c-38.4 0-70.4-32-70.4-70.4 0-38.4 32-70.4 70.4-70.4 38.4 0 70.4 32 70.4 70.4 0 38.4-32 70.4-70.4 70.4z m249.6 0c-38.4 0-70.4-32-70.4-70.4 0-38.4 32-70.4 70.4-70.4 38.4 0 70.4 32 70.4 70.4-6.4 38.4-38.4 70.4-70.4 70.4z\" p-id=\"1990\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/msg.svg
// module id = FfkO
// module chunks = 44